export enum TYPE_FILE {
  PDF = 'application/pdf',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  GIF = 'image/gif',
  MP4 = 'video/mp4',
  MOV = 'video/quicktime',
  MP3 = 'audio/mpeg',
  CSV = 'text/csv',
  TXT = 'text/plain',
  M4A = 'audio/x-m4a'
}

export enum AttachmentColEnum {
  NAME = 'originalName',
  TYPE = 'type',
  POLICY = 'policy',
  DESCRIPTION = 'description',
  UPLOADED_BY = 'addBy',
  CREATED_AT = 'createdAt'
}
